export const nemipayTranslation = {
  nemipay: {
    name: 'nemipay',
    menu: {
      company: {
        plural: { formal: 'Empresas', informal: 'empresas', },
        singular: { formal: 'Empresa', informal: 'empresa', },
      },
      commerce: {
        plural: { formal: 'Comercios', informal: 'comercios', },
        singular: { formal: 'Comercio', informal: 'comercio', },
      },
      branch: {
        plural: { formal: 'Sucursales', informal: 'sucursales', },
        singular: { formal: 'Sucursal', informal: 'sucursal', },
      },
    },
    duplicateTab: {
      title: 'Aplicación ya abierta en otra pestaña',
      description: 'Solo puede haber una pestaña activa de NemiPay a la vez.',
      instruction: 'Cierre esta pestaña manualmente (Ctrl+W o el botón X del navegador) y utilice la pestaña donde ya está abierta la aplicación.',
    },
    publicView: {
      landing: {
        cn: '@:menu.company.singular.formal desconocida',
        indication: '@:menu.company.singular.formal',
      },
      forgotPassword: {
        setupPassword: {
          cn: '@:menu.company.singular.formal desconocida',
          indication: '@:menu.company.plural.formal',
        },
      },
    },
    credentials: {
      validation: {
        commpixRequired: 'Credenciales Comm.PIX no configuradas.',
        commpixRequiredMsg: 'Para acceder a esta funcionalidad necesitás configurar tus credenciales de Comm.PIX en la sección de Integraciones.',
        masspaymentRequired: 'Credenciales Masspayment no configuradas.',
        masspaymentRequiredMsg: 'Para acceder a esta funcionalidad necesitás configurar tus credenciales' +
          ' de Masspayment en la sección de Integraciones.',
        commpixOrMantecaRequired: 'Credenciales Comm.PIX o Manteca no configuradas.',
        commpixOrMantecaRequiredMsg: 'Para acceder a esta funcionalidad necesitás configurar tus credenciales' +
          ' de Comm.PIX o Manteca en la sección de Integraciones.',
      },
      commpix: {
        title: 'Credenciales CommPIX',
        helperHeader: 'Ayuda para credenciales CommPIX:',
        helperText1: 'Asegúrate de que tus credenciales sean válidas para el sistema CommPIX, ' +
          'de lo contrario, recibirás un error.',
        helperText2: 'Si deseas actualizar tu contraseña, primero ve al sitio de gestión de CommPIX, ' +
          'cambia tu contraseña y luego actualízala en el sistema.',
      },
      masspayment: {
        title: 'Credenciales MassPayment.PIX',
        helperHeader: 'Ayuda para credenciales MassPayment.PIX:',
        helperText1: 'Asegúrate de que tus credenciales sean válidas para el sistema MassPayment.PIX, ' +
          'de lo contrario, recibirás un error.',
        helperText2: 'Si deseas actualizar tu contraseña, primero ve al sitio de gestión de MassPayment.PIX, ' +
          'cambia tu contraseña y luego actualízala en el sistema.',
      },
      pvs: {
        title: 'Credenciales PVS',
        helperHeader: 'Ayuda para credenciales PVS:',
        helperText1: 'Asegúrate de que tus credenciales sean válidas para el sistema PVS, de lo contrario, recibirás un error.',
        helperText2: 'Si aún no contás con tus credenciales, ingresá a la página oficial de PVS.',
        clientIdLabel: 'ID de cliente',
        clientSecretLabel: 'Clave secreta de cliente',
      },
      manteca: {
        title: 'Manteca',
        helperHeader: 'Ayuda para integración Manteca:',
        helperText1: 'Este es el identificador de usuario asignado por Manteca para tu cuenta.',
        userAnyIdLabel: 'ID de Usuario',
        emptyState: 'No hay usuarios de Manteca configurados',
      },
      individualAccount: {
        label: 'Utilizar cuenta individual',
        helperText1: 'Al seleccionar cuenta individual solo su usuario podrá utilizar las credenciales de integración.',
        yes: 'Sí',
        no: 'No',
      },
      view: {
        emptyState: 'No hay credenciales configuradas',
        createButton: 'Crear credenciales',
        emailLabel: 'Email',
        individualAccountLabel: 'Cuenta individual',
      },
    },
    home: {
      title: 'Home',
      lackOfCommpixCredentials: 'Credenciales de Comm.PIX no configuradas.',
      lackOfCommpixCredentialsMsg: 'Comunicate con el administrador de tu cuenta para configurar las credenciales y habilitar esta funcionalidad.',
      lackOfMasspaymentCredentials: 'Credenciales de MassPayment no configuradas.',
      lackOfMasspaymentCredentialsMsg: 'Comunicate con el administrador de tu cuenta para configurar las credenciales de MassPayment y ' +
      ' habilitar esta funcionalidad.',
      lackOfCommpixOrMantecaCredentials: 'Credenciales Comm.PIX o Manteca no configuradas.',
      lackOfCommpixOrMantecaCredentialsMsg: 'Para acceder a esta funcionalidad necesitás configurar tus credenciales' +
        ' de Comm.PIX o Manteca en la sección de Integraciones.',
      buttons: {
        createLink: 'Crear link de pago',
        createQR: 'Crear QR de pago',
        createBolepix: 'Crear BolePIX',
        withdraw: 'Retirar comisión',
        payout: 'Crear payout',
        support: 'Soporte',
        dailyStatement: 'Obtener reporte',
        createQrPayins: 'Crear Payins QR',
        desc: {
          qrCode: 'Genera un QR estático o dinámico.',
          paymentLink: 'Genera un link para cobrar online.',
          bolepix: 'Genera un BolePIX para enviar por email o teléfono.',
          withdraw: 'Retira las comisiones a tu cuenta bancaria.',
          payout: 'Genera un payout de forma rápida y segura.',
          support: 'Contacta a soporte para ayuda.',
          dailyStatement: 'Reporte diario de transacciones.',
          qrPayins: 'Genera un QR para recibir pagos.',
        },
      },
    },
    payments: {
      dinamicPayment: {
        title: 'Links de pago',
        refreshButton: 'Actualizar',
        newPaymentButton: 'Crear pago',
      },
      scanToPay: {
        title: 'Pagos con QR',
        refreshButton: 'Actualizar',
        newPaymentButton: 'Crear pago',
      },
      bolepix: {
        title: 'BolePIX',
        refreshButton: 'Actualizar',
        newPaymentButton: 'Crear pago',
      },
      qrPayins: {
        title: 'Payins QR',
        refreshButton: 'Actualizar',
        newPaymentButton: 'Crear pago',
      },
      transferences: {
        title: 'Transferencias',
        refreshButton: 'Actualizar',
      },
      modalDetails: {
        title: 'Detalle de transacción',
        id: 'ID',
        status: 'Estado',
        company: 'Empresa',
        commerce: 'Comercio',
        branch: 'Sucursal',
        paymentMode: 'Modo de pago',
        paymentMethod: 'Método de pago',
        operationType: 'Tipo de operación',
        expirationDate: 'Fecha de expiración',
        total: 'Total',
        exchangeRate: 'Tasa de cambio',
        comments: 'Comentarios',
        externalComments: 'Comentario externo',
        createdBy: 'Creado por',
        createdAt: 'Creado en',
        dueAt: 'Fecha de vencimiento',
        interestAt: 'Fecha de inicio de intereses',
        interestPercent: 'Interés (%)',
        fineAt: 'Fecha de cargo por mora',
        fine: 'Cargo por mora',
        payerId: 'ID del pagador',
        payerName: 'Nombre / Razón social',
        accountHolderName: 'Nombre del titular',
        accountBankNumber: 'Código del banco',
        accountBranchNumber: 'Número de sucursal',
        accountNumber: 'Número de cuenta',
        bankAccountTypeDescription: 'Tipo de cuenta',
        pixKey: 'Clave PIX',
        payoutPixTypeDescription: 'Tipo de clave PIX',
        authorizedBy: 'Autorizado por',
        authorizationMotive: 'Motivo de autorización',
        errorCode: 'Código de error',
        errorDescription: 'Mensaje de error',
        bankAccountHolder: 'Titular',
        bankAccountType: 'Tipo de Cuenta',
        bankName: 'Banco',
        bankBranchNumber: 'Sucursal',
        bankAccountNumber: 'Número de Cuenta',
      },
      receipt: {
        title: 'RECIBO DE PAGO',
        transactionInfo: 'INFORMACION DE LA TRANSACCION',
        operationDetails: 'DETALLES DE LA OPERACION',
        date: 'Fecha',
        payer: 'Pagador',
        value: 'Valor',
        exchangeRate: 'Cotización',
        localValue: 'Valor en moneda local',
        chargeId: 'ID',
        footer: 'Desarrollado por PadiPay',
      },
      form: {
        id: 'ID',
        paymentMethod: 'Método de pago',
        operationType: 'Tipo de operación',
        expiration: 'Expira en',
        expireAt: 'Expiración',
        amountUsd: 'Monto',
        quotation: 'Cotización',
        amount: 'Monto',
        internalComment: 'Comentarios internos',
        externalComment: 'Comentarios externos',
        paymentMode: 'Modo de pago',
        dueDate: 'Fecha de vencimiento',
        expiredDate: 'Fecha de expiración',
        dueDateTooltip: `Fecha límite para pagar el monto original.
        Los pagos realizados después de esta fecha pueden generar intereses y cargos por mora`,
        expiredDateTooltip: `El pago debe completarse antes de esta fecha.
        Después de eso, caduca.
        La fecha de expiración debe estar dentro de los 59 días posteriores a la fecha de vencimiento.`,
        fineDate: 'Fecha de cargo por mora',
        fineDateTooltip: `Se aplicará un cargo por mora después de la fecha de vencimiento.
        Puedes definir un monto fijo o un porcentaje del valor original.
        El cargo no debe exceder el 2% del importe original de BolePIX`,
        fineValue: 'Importe del cargo por mora',
        fineValueTooltip: 'El valor no debe exceder R$ {maxFineValue}',
        interestDate: 'Fecha de inicio de intereses',
        interestDateTooltip: `Se cobrará interés diariamente a partir de la fecha de vencimiento.
        El valor debe definirse únicamente como un porcentaje.
        El valor no debe exceder el 1% del monto total de BolePIX`,
        interestValue: 'Valor del interés',
        interestValueTooltip: 'El valor no debe exceder el 1% mensual',
        datePlaceholder: 'Seleccionar fecha',
        phoneNumber: 'Número de teléfono',
        email: 'Correo electrónico',
        payerId: 'Identificación del pagador (CPF/CNPJ)',
        payerIdTooltip: `Número de identificación del pagador que identifica quién efectuará el pago de la transacción. 
        Se acepta CPF para personas físicas o CNPJ para empresas. 
        Se realizará un reembolso si el CPF/CNPJ no coincide con el titular de la cuenta.`,
        payerName: 'Nombre / Razón social',
        payerLastName: 'Apellido',
      },
      modalPayment: {
        nextButtonText: 'Siguiente',
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        footerLegend: `Se aplican estimaciones de tarifas y costos a esta transacción. 
        Los tipos de cambio pueden fluctuar desde ahora hasta el momento del pago.`,
        successMessage: 'Pago enviado correctamente',
      },
      modalQRPayment: {
        title: 'Nuevo pago QR',
        subtitle: 'Realiza tu pago',
        summary: {
          title: 'Resumen del pago',
          vendor: 'Vendedor:',
          transactionType: 'Tipo de transacción:',
          usdAmount: 'Monto en USD: ',
          brlAmount: 'Monto en BRL: ',
          exchangeRate: 'Tasa de cambio:',
          paymentMethod: 'Método de pago:',
          paymentMode: 'Modo de pago:',
        },
      },
      modalPaymentLink: {
        title: 'Nuevo Link de pago',
        subtitle: 'Puedes enviar el enlace de pago con las siguientes opciones',
        sendButton: 'Enviar',
      },
      modalBolepixPayment: {
        title: 'Nuevo pago BolePIX',
        phoneNumber: 'Número de teléfono',
        email: 'Correo electrónico',
        payerId: 'Identificación del pagador (CPF/CNPJ)',
        payerIdTooltip: `Número de identificación del pagador que identifica quién efectuará el pago de la transacción. 
        Se acepta CPF para personas físicas o CNPJ para empresas. 
        Se realizará un reembolso si el CPF/CNPJ no coincide con el titular de la cuenta.`,
        payerName: 'Nombre y apellido',
        state: 'Estado',
        city: 'Ciudad',
        zipCode: 'Código postal',
        successTitle: 'BolePIX creado correctamente',
        successMessage: 'El BolePIX se generará en un plazo de 1 hora y, una vez esté listo, tu cliente lo recibirá por correo electrónico y/o SMS.',
      },
      externalComment: '{company}, {commerce}, {branch} está solicitando un pago de {currency} {amount}',
    },
    pix: {
      withdrawals: {
        title: 'Comisiones',
        card: {
          title: 'Balance de retiros',
          tooltip: 'Este monto corresponde a tus comisiones obtenidas en Comm.PIX',
          buttonCardwithdraw: 'Retirar',
        },
        modal: {
          title: 'Cotización de retiros',
          currency: 'Moneda',
          exchangeCurrency: 'Moneda de intercambio',
          exchangeRate: 'Tasa de cambio',
          originalBalance: 'Monto del balance',
          convertedBalance: 'Monto a recibir',
          reviewMessage: 'Por favor revisa los detalles de la cotización antes de confirmar tu retiro.',
          tooltip: 'Esta cotización es válida por 5 minutos',
          noBalanceMessage: 'No tienes saldo suficiente para realizar un retiro en este momento.',
        },
      },
      balance: {
        title: 'Estado de cuenta',
        newPayout: 'Crear payout',
        card: {
          title: 'Saldo disponible',
          tooltip: 'Este monto corresponde a tu saldo disponible aún no retirado en MassPayments.PIX',
        },
      },
      padipix: {
        card: {
          title: 'Saldo PadiPIX',
          tooltip: 'Saldo disponible en tu cuenta PadiPIX. Saldo global de tu compañía.',
          empty: 'Sin saldo para mostrar',
        },
      },
      processPayouts: {
        ok: 'Los payouts han sido procesados correctamente',
        processModalTitle: 'Procesar payouts',
        error: {
          notProcessedPayouts: 'Los siguientes payouts no pudieron ser procesados:',
          default: 'Error procesando los payouts',
        },
        disclaimer: 'Solo se completarán los payouts por un monto menor o igual al saldo disponible en cuenta, hasta agotar el disponible.',
      },
      cancelPayouts: {
        ok: 'Los payouts han sido cancelados correctamente',
        cancelModalTitle: 'Cancelar payouts',
        error: {
          default: 'Error cancelando los payouts',
        },
        disclaimer: 'Solo se cancelarán los payouts seleccionados que se encuentren en estado de fondos pendientes.',
        motive: 'Cancelado manualmente por el usuario ',
      },
      payoutsConfiguration: {
        title: 'Configuración de Payouts',
        helperHeader: 'Configuración de Autorización de Payouts',
        helperText1: 'Puedes configurar un monto mínimo a partir del cual tus Payouts requieren autorización de Supervisor.',
        helperText2: 'La configuración solo aplica a usuarios que requieran autorización de supervisores, ' +
          'si el monto del Payout es menor al requerido, la operación se autorizará automáticamente por sistema.',
        form: {
          authorizationStartsFrom: 'Autorización a partir de',
        },
        audit: {
          title: 'Información de Auditoría',
          createdBy: 'Creado por',
          updatedBy: 'Última actualización por',
        },
        messages: {
          saveSuccess: 'Configuración guardada correctamente',
          saveError: 'Error al guardar la configuración',
          loadError: 'Error al cargar la configuración',
        },
      },
      pendingPayouts: {
        title: 'Payouts pendientes',
        filters: {
          createdBy: 'Creado por',
          id: 'Id',
        },
        authorizePayouts: 'Autorizar payouts',
        authorizeModalTitle: 'Payouts pendientes de autorización',
        confirmAuthorize: 'Confirmar',
        emptyMessage: 'No hay payouts pendientes de autorización',
        authorizeOption: 'Autorizar',
        rejectOption: 'Rechazar',
        messageLabel: 'Motivo de la acción',
        messagePlaceholder: 'Escriba el motivo detallado aquí...',
        defaultMessageAuthorize: 'Autorizado por supervisor',
        defaultMessageReject: 'Rechazado por supervisor',
        actionPanelTitle: 'Panel de Acción',
        disclaimer: 'Solo se completarán los payouts con autorización válida.',
        messages: {
          successAuthorize: 'Payouts autorizados correctamente',
          successReject: 'Payouts rechazados correctamente',
          notProcessed: 'Los siguientes payouts no pudieron ser procesados:',
          errorAuthorize: 'Error al autorizar los payouts',
          errorReject: 'Error al rechazar los payouts',
        },
      },
    },
    massPayments: {
      payout: {
        modal: {
          title: 'Nuevo payout',
          confirmButtonText: 'Confirmar',
          id: 'ID',
          amount: 'Monto',
          payerId: 'Documento titular',
          payerIdTooltip: 'Documento vinculado al titular de la cuenta receptora. Puede ser CPF o CNPJ.',
          payoutMethod: 'Método de pago',
          payoutPixType: 'Tipo clave PIX',
          pixKey: 'Clave PIX',
          pixKeyPhoneTooltip: 'Solo se permiten números de teléfono de Brasil en formato internacional. Ej.: +55 11 91234-5678.',
          accountHolderName: 'Nombre titular',
          accountHolderNameTooltip: 'Nombre de la persona vinculada a la cuenta bancaria.',
          payoutBankAccountType: 'Tipo de cuenta',
          accountBankNumber: 'Banco',
          accountBankNumberPlaceholder: '# Banco',
          accountBankNumberSearch: 'Buscar banco',
          accountBankNumberSearchPlaceholder: 'Buscar por nombre',
          accountBankNumberTooltip: 'Número del banco de la cuenta receptora.',
          accountBranchNumber: 'Sucursal',
          accountBranchNumberTooltip: 'Número que identifica la sucursal de la cuenta bancaria.',
          accountNumber: 'Número',
          accountNumberTooltip: 'Número de la cuenta bancaria.',
          successMessage: 'El payout está en cola para ser procesado.',
          errorMessage: 'Error al procesar el payout',
        },
      },
      modalQrPayins: {
        title: 'Nuevo Payin QR',
        subtitle: 'Realiza tu pago',
      },
    },
    reports: {
      transactionHistory: {
        title: 'Historial de transacciones',
        dateRange: 'Rango de fechas',
        paymentMode: 'Modo',
        paymentStatus: 'Estado',
        externalId: 'ID externo',
        payerName: 'Nombre del pagador',
        payerEmail: 'Correo electrónico del pagador',
        payerPhone: 'Teléfono del pagador',
        payerId: 'Documento titular',
        viewCompanyTransactions: 'Ver transacciones de la empresa',
        includePayments: 'Incluir Pagos',
        includePayouts: 'Incluir Payouts',
        payments: 'Pagos',
        payouts: 'Payouts',
        payoutMethod: 'Tipo',
        payoutStatus: 'Estado',
      },
    },
    buttonTexts: {
      ok: 'Aceptar',
      cancel: 'Cancelar',
      close: 'Cerrar',
      save: 'Guardar',
      delete: 'Eliminar',
      edit: 'Editar',
      update: 'Actualizar',
      search: 'Buscar',
      clear: 'Limpiar',
      process: 'Procesar pagos',
      viewReceipt: 'Ver comprobante',
      printReceipt: 'Imprimir recibo',
      create: 'Crear',
      createPayin: 'Crear PAYIN',
      createPayout: 'Crear PAYOUT',
      createCombined: 'Crear PAYIN & PAYOUT',
    },
    error: {
      withdrawals: {
        409: 'Ya hay una solicitud de retiro en proceso',
        default: 'Error al procesar el retiro',
      },
      credentials: {
        duplicated_credential: 'Ya existe ese tipo de credencial, no se puede actualizar.',
      },
    },
    salesReports: {
      transactionStatistics: {
        title: 'Estadísticas de Pagos',
        subtitlePayins: 'Estados de pago',
        subtitlePayouts: 'Estados de pago salientes (payouts)',
        cardHeaders: {
          totalPayments: 'Pagos totales',
          completedPayments: 'Completados',
          totalAmount: 'Total Completados',
          averagePayments: 'Promedio',
          monthly: 'Mensual completadas',
          annual: 'Diarias completadas',
          transactionsCount: 'Número de transacciones',
          dailyTransactions: 'Transacciones por día',
          pending: 'Pendientes',
          completed: 'Completados',
          refunded: 'Reembolsados',
          cancelled: 'Cancelados',
          expired: 'Expirados',
          failed: 'Erroneos',
          created: 'Creados',
          awaitingFunds: 'Esperando fondos',
        },
        yes: 'Sí',
        no: 'No',
        showCompanyTransactions: 'Ver transacciones de la empresa',
      },
      dailyTransactionsStatement: {
        title: 'Reporte diario de transacciones',
        downloadButton: 'Obtener reporte',
        downloadButtonTooltip: 'Descargar reporte',
        table: {
          id: 'ID',
          date: 'Fecha',
          download: 'Descargar',
        },
        modal: {
          title: 'Generar reporte diario de transacciones',
          confirmButton: 'Confirmar',
          successMessage: 'El reporte se descargó correctamente.',
          errorMessage: 'Error al descargar el reporte.',
        },
        form: {
          date: 'Fecha',
          helperTitle: 'Información',
          helperText1: 'Seleccione una fecha válida dentro del último mes.',
          helperText2: 'El reporte se descargará automáticamente una vez que se genere.',
          helperText3: 'El reporte incluye todas las operaciones de la empresa, ' +
            'independientemente del comercio y la sucursal seleccionados.',
          helperText4: 'Se recomienda generar el reporte una vez al día, al cierre del horario comercial, ' +
            'ya que el proveedor permite una única generación por fecha.',
        },
        filters: {
          date: 'Fecha',
          placeholder: 'Seleccionar fecha',
        },
      },
    },
  },
};
